/*
 * @Description: 一周数字品牌价值
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 16:16:28
 * @LastEditTime: 2019-03-21 15:44:03
 */

import moment from 'moment'
import { createSubtext } from './public';

const valueTrend = (data, query) => {
  const summary = data.summary;
  const charts = data.charts;
  
  // const data1 = this.props.json


  let timeArr = []
  const len=charts.length

  for (let i = 0; i < charts.length; i++) {
    timeArr.unshift(moment(query.statisDate).subtract(i, 'days').format('YYYY.MM.DD'))
  }

  const seriesData = charts.map((item) => {
    return {
      name: 'DB总值',
      type: 'bar',
      value: item,
      label: {
        normal: {
          // show: this.props.showLabel,
          position: item >= 0 ? 'top' : 'bottom',
          color: '#000',
          fontWeight: 'bold'
        }
      }
    }
  });
  



  return {
    title: {
      text: `一周数字品牌价值 - ${query.brandName}`,
      subtext: createSubtext(query),
      // sublink:'',
      x: '20'
    },
    color: [
      '#ffd70d', '#fac8a7', '#abd9f2', '#f1b1ad'
    ],
    legend: {
      show: false,
      data: [
        '微信', '微博', '知乎', '今日头条', 'DB总值'
      ],
      align: 'left'
    },
    toolbox: {
      right: 20,
      show: false,
      feature: {
        dataView:{
          show:true
        },
        restore: {
          show: true
        },
        saveAsImage: {
          show: true
        }
      }
    },
    grid: {
      top: 80,
      bottom: 30
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    xAxis: {
      data: timeArr,
      type: 'category',
      silent: false,
      splitLine: {
        show: false
      }
    },
    yAxis: {
        type: 'value'
    },
    series: [
      {
        name: 'DB总值',
        type: 'bar',
        itemStyle: {
          normal:{
            // color: this.props.color
            
          }
        },
        barWidth:len>7?'0':'40',
        barMaxWidth:'40',
        label: {
          normal: {
            show: timeArr.length <=10 ? true : false,
            position: 'top',
            color: '#000',
            fontWeight: 'bold'
          }
        },
        data: seriesData,
        
        // yAxisIndex:1
      }
    ],
    animationEasing: 'elasticOut',
    animationDelayUpdate: function (idx) {
      return idx * 5;
    }
  }
};


export default valueTrend;


// WEBPACK FOOTER //
// src/chart/valueTrend.js